// extracted by mini-css-extract-plugin
module.exports = {"discountInput":"CreateSaleForm_discountInput__3hz2Y","datepicker":"CreateSaleForm_datepicker__3kS2m","createSaleBtn":"CreateSaleForm_createSaleBtn__mhW8J"};